export default {
  form: {
    title: "Logga in på Xplora",
    username: "Förälders telefonnummer",
    password: "Skriv in koden som du har mottagit på SMS.",
    language: "Språk",
    submit: "Logga in",
    continue: "Nästa",
    usernameValidationMessage: "Ange förälders telefonnummer",
    otpHint: "",
    phoneNumberInputInstructions:
      "Vänligen ange ditt telefonnummer utan landskod (+46) eller inledande nolla.\nExempel: 701234567\nAnge inte: 0701234567, 46701234567 eller 460701234567",
  },
  logoutDialog: {
    title: "Inloggad som",
  },
  loginInfo: {
    title: "Har du ett abonnemang från Xplora?",
    content:
      "OBS: Om prenumerationen gäller en Xplora-klocka, ange föräldrarnas mobilnummer, inte smartklockans. \n \n Observera att det kan ta upp till 30 minuter från beställning tills du kan logga in.",
  },
} as const;
